export default __webpack_public_path__ + "static/media/icon_CCP.7add71ab.png";